import { useState, useEffect } from 'react'
import { listClusters } from '@/services/cluster'

export const useCluster = (limit = 50, offset = 0) => {
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchClusters = async () => {
      try {
        setLoading(true)
        setError(null)
        const response = await listClusters(limit, offset)
        setData(response.data || [])
      } catch (err: any) {
        setError(err.message || 'Failed to fetch clusters')
      } finally {
        setLoading(false)
      }
    }

    fetchClusters()
  }, [limit, offset])

  return { data, loading, error }
}
